import type { ObjectType } from '@/@types/graphql-types';

export interface TitleModalData {
	objectId: number;
	objectType: ObjectType;
	content: {
		title: string;
		originalReleaseYear?: number | null;
	};
}

export function openTitleDetailModal(title: TitleModalData, source: string): void {
	Promise.all([
		import('@/components/modals/TitleDetailModal.vue'),
		import('@/helpers/vfm/vfm-helper'),
		import('@/helpers/vfm/modal-helper'),
		import('@/helpers/entity-helper'),
	]).then(([{ default: TitleDetailModal }, { VFMHelper }, { ModalHelper }, { getTitleContextEntityId }]) => {
		// Close other open modals
		VFMHelper.close();

		// Open title detail modal
		ModalHelper.openModal(
			TitleDetailModal,
			{
				entityId: getTitleContextEntityId(title.objectType, title.objectId, source),
				titleName: title.content.title,
				releaseYear: title.content.originalReleaseYear,
			},
			{ cssClass: 'jw-title-detail-modal' }
		);
	});
}
